import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Button,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableClient from "../../Components/ClientConfig/TableClient";
import { MdAdd } from "react-icons/md";

const ClientConfig = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [filterValue, setFilterValue] = useState("");
  const [option ,setOption] = useState("phone");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();


  const fetchFunction = async () => {
    const body = new FormData();
    body.append("clientId", id);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterType", option);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/getclientconfig`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading: isLoading,
    mutate: getClientMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

    useEffect(() => {
      const handler = setTimeout(() => {
        getClientMutate();
      }, 500);
  
      return () => {
        clearTimeout(handler);
      };
    }, [filterValue, startDate, endDate]);


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Client Config")}
                <span>/{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
            <UploadWrapper>
              <Button type="button" onClick={(item) => navigate(`/clientconfig/${id}/addclientconfig`)}>
                <MdAdd className="text-white w-5 h-5" />{" "}
                <p className="text-sm">{"Add Config"}</p>
              </Button>
            </UploadWrapper>
          </div>

          {!error && !isLoading && data && (
            <TableWrapper>
              <TableClient
                // ApiData={error ? [] : data?.data?.data}
                ApiData={error ? []:
                Array.isArray(data?.data?.data)
                    ? data.data.data
                    : data?.data?.data
                    ? [data.data.data]   // wrap object into array
                    : []
                }
                userType={user.userType}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;

export default ClientConfig;